const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const menuIconURI = "data:image/png;base64,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"

class PythonControlsExtension {
    constructor(runtime) {
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonControls",
            color1: '#dc143c',
            name: "Python Controls",
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "python_if",
                    blockType: BlockType.CONDITIONAL,
                    text: "if [CONDITION]",
                    arguments: {
                        CONDITION: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        }
                    }
                },
                {
                    opcode: "python_elif",
                    blockType: BlockType.CONDITIONAL,
                    text: "elif [CONDITION]",
                    arguments: {
                        CONDITION: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: false
                        }
                    }
                },
                {
                    opcode: "python_else",
                    blockType: BlockType.CONDITIONAL,
                    text: "else",
                    arguments: {}
                },
                {
                    opcode: "python_relational",
                    blockType: BlockType.BOOLEAN,
                    text: "[LEFT] [OPERATOR] [RIGHT]",
                    arguments: {
                        LEFT: {
                            type: ArgumentType.STRING, // Changed from NUMBER to STRING
                            defaultValue: "0"
                        },
                        OPERATOR: {
                            type: ArgumentType.STRING,
                            menu: 'relationalOperators',
                            defaultValue: '=='
                        },
                        RIGHT: {
                            type: ArgumentType.STRING, // Changed from NUMBER to STRING
                            defaultValue: "0"
                        }
                    }
                },
                {
                    opcode: "python_logical",
                    blockType: BlockType.BOOLEAN,
                    text: "[LEFT] [OPERATOR] [RIGHT]",
                    arguments: {
                        LEFT: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        },
                        OPERATOR: {
                            type: ArgumentType.STRING,
                            menu: 'logicalOperators',
                            defaultValue: 'and'
                        },
                        RIGHT: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: false
                        }
                    }
                },
                {
                    opcode: "python_not",
                    blockType: BlockType.BOOLEAN,
                    text: "not [CONDITION]",
                    arguments: {
                        CONDITION: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        }
                    }
                },
                {
                    opcode: "python_while",
                    blockType: BlockType.CONDITIONAL,
                    text: "while [CONDITION]",
                    arguments: {
                        CONDITION: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        }
                    }
                },
                {
                    opcode: "python_for_range",
                    blockType: BlockType.CONDITIONAL,
                    text: "for [VAR] in range([START], [END], [STEP])",
                    arguments: {
                        VAR: {
                            type: ArgumentType.STRING, // Change from STRING to VARIABLE
                            defaultValue: 'i'
                        },
                        START: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        END: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        },
                        STEP: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: "python_for_iterable",
                    blockType: BlockType.CONDITIONAL,
                    text: "for [VAR] in [ITERABLE]",
                    arguments: {
                        VAR: {
                            type: ArgumentType.STRING, // Change from STRING to VARIABLE
                            defaultValue: 'item'
                        },
                        ITERABLE: {
                            type: ArgumentType.VARIABLE,
                            defaultValue: 'list'
                        }
                    }
                },
                {
                    opcode: "get_loop_variable",
                    blockType: BlockType.REPORTER,
                    text: "[VAR]",
                    arguments: {
                        VAR: {
                            type: ArgumentType.STRING,
                            defaultValue: 'i'
                        }
                    }
                },
                // {
                //     opcode: "python_continue",
                //     blockType: BlockType.COMMAND,
                //     text: "continue",
                //     arguments: {}
                // },
                {
                    opcode: "python_break",
                    blockType: BlockType.COMMAND,
                    text: "break",
                    arguments: {}
                }
            ],
            menus: {
                relationalOperators: {
                    items: ['==', '!=', '<', '<=', '>', '>=']
                },
                logicalOperators: ['and', 'or']
            }
        };
    }

    python_if(args, util) {
        // Get the condition and convert it to boolean
        const condition = Cast.toBoolean(args.CONDITION);
        
        // Store the condition result in the thread state
        util.thread.lastConditionResult = condition;
        
        // Only start the if branch if condition is true
        if (condition) {
            util.startBranch(1, false);
        }
    }

    python_else(args, util) {
        // Only execute else if the last condition was false
        if (util.thread.lastConditionResult === false) {
            util.startBranch(1, false);
        }
    }

    python_elif(args, util) {
        const condition = Cast.toBoolean(args.CONDITION);

        // Execute only if no previous condition matched
        if (!util.thread.lastConditionResult && condition) {
            util.startBranch(1, false); // Branch 1 = 'elif' block
        }

        util.thread.lastConditionResult = condition;
    }

    python_relational(args) {
        const left = Cast.toString(args.LEFT);
        const right = Cast.toString(args.RIGHT);
        const operator = Cast.toString(args.OPERATOR);

        // Try numeric comparison first
        if (!isNaN(left) && !isNaN(right)) {
            const numLeft = Cast.toNumber(left);
            const numRight = Cast.toNumber(right);
            
            switch (operator) {
                case '==': return numLeft === numRight;
                case '!=': return numLeft !== numRight;
                case '<': return numLeft < numRight;
                case '<=': return numLeft <= numRight;
                case '>': return numLeft > numRight;
                case '>=': return numLeft >= numRight;
            }
        }

        // Fall back to string comparison
        switch (operator) {
            case '==': return left === right;
            case '!=': return left !== right;
            case '<': return left < right;
            case '<=': return left <= right;
            case '>': return left > right;
            case '>=': return left >= right;
        }
        return false;
    }

    python_logical(args) {
        const left = Cast.toBoolean(args.LEFT);
        const right = Cast.toBoolean(args.RIGHT);
        const operator = args.OPERATOR;

        switch (operator) {
            case 'and':
                return left && right;
            case 'or':
                return left || right;
            default:
                return false;
        }
    }

    python_not(args) {
        const condition = Cast.toBoolean(args.CONDITION);
        return !condition;
    }

    python_while(args, util) {
        // Handle break
        if (util.thread.breakLoop) {
            delete util.thread.breakLoop;
            return;
        }
        // Handle continue
        // if (util.thread.continueLoop) {
        //     delete util.thread.continueLoop;
            // Just skip to the next iteration (re-check condition)
        // }
        const condition = Cast.toBoolean(args.CONDITION);
        if (condition) {
            util.startBranch(1, true); // Run the loop body and yield
        }
    }

    python_for_range(args, util) {
        if (util.thread.breakLoop) {
            delete util.thread.breakLoop;
            return;
        }
        const start = Cast.toNumber(args.START);
        const end = Cast.toNumber(args.END);
        const step = Cast.toNumber(args.STEP);
        const varName = args.VAR;
        
        if (typeof util.thread.loopCounter === 'undefined') {
            util.thread.loopCounter = start;
            util.thread.loopStep = step;
            util.thread.currentLoopVariable = varName;
        }
    
        if ((step > 0 && util.thread.loopCounter < end) ||
            (step < 0 && util.thread.loopCounter > end)) {
            // Create or update the variable in Scratch's variable system
            const variable = util.target.lookupOrCreateVariable(varName, varName);
    
            variable.value = util.thread.loopCounter;
            util.target.variables[varName] = variable;
    
            util.thread.currentLoopValue = util.thread.loopCounter;
    
            util.thread.loopCounter += util.thread.loopStep;
    
            util.startBranch(1, true);
    
            util.yield();
            return;
        } else {
            delete util.thread.loopCounter;
            delete util.thread.currentLoopValue;
            delete util.thread.currentLoopVariable;
        }
    }
    
    python_for_iterable(args, util) {
        if (util.thread.breakLoop) {
            delete util.thread.breakLoop;
            return;
        }

        let iterable;
        const varName = args.VAR;
    
        try {
            iterable = JSON.parse(args.ITERABLE);
        } catch (e) {
            iterable = Array.isArray(args.ITERABLE) ? args.ITERABLE : args.ITERABLE.split('');
        }
    
        if (typeof util.thread.loopCounter === 'undefined') {
            util.thread.loopCounter = 0;
            util.thread.iterableItems = iterable;
            util.thread.currentLoopVariable = varName;
        }
    
        if (util.thread.loopCounter < util.thread.iterableItems.length) {
            const variable = util.target.lookupOrCreateVariable(varName, varName);
    
            variable.value = util.thread.iterableItems[util.thread.loopCounter];
            util.target.variables[varName] = variable;
    
            util.thread.loopCounter++;
    
            util.startBranch(1, true);
        } else {
            delete util.thread.loopCounter;
            delete util.thread.iterableItems;
            delete util.thread.currentLoopVariable;
        }
    }

    get_loop_variable(args, util) {
        const varName = args.VAR;
        const variable = util.target.lookupOrCreateVariable(varName, varName);
        return variable ? variable.value : 0;
    }


    // python_continue(args, util) {
    //     // Logic to handle continue
    //     util.thread.continueLoop = true;
    //     return;
    // }

    python_break(args, util) {
        // Logic to handle break
        util.thread.breakLoop = true;
        return;
    }
}

module.exports = PythonControlsExtension;